{
	"title": "나카자와 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "전체 화면",
		"achievements": "업적",
		"reset": "초기화",
		"language": "언어"
	},
	"achievements": {
		"title": "업적",
		"noAchievements": "아직 획득한 업적이 없습니다. 계속 클릭하세요!",
		"unlocked": "업적 달성: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 초보자 토끼",
		"carrotSnatcher": "🥕 채소 도둑",
		"bunnyBerserker": "😡 광분한 토끼",
		"hopPunk": "🎸 아나키스트 토끼",
		"bunnyNinja": "🥷 조용하지만 치명적인 토끼",
		"expert": "🌟 전문 점퍼",
		"master": "👑 당근왕",
		"carrotpocalypse": "🥕 채소밭 파괴자",
		"bunnyOverlord": "😈 토끼굴의 최고 지배자",
		"chaosHare": "🌪️ 혼돈의 요원",
		"carrotCultist": "⛪ 당근 교단의 대제사장",
		"bunnyberryPie": "🥧 환각 파이의 달인",
		"rabbitHole": "🕳️ 양자 터널 굴착기",
		"moonRabbit": "🌙 달토끼",
		"bunnyDoom": "💀 토끼 종말의 전령",
		"carrotNuke": "☢️ 핵당근 소유자",
		"bunnyMatrix": "🤖 토끼 매트릭스의 오류",
		"cosmicHare": "🌌 우주 토끼의 각성",
		"warrenSingularity": "🕳️ 토끼굴 특이점 달성",
		"eternalBunny": "♾️ 영원한 토끼"
	},

	"messages": {
		"prophecy": "고대의 클릭 예언이 펼쳐지기 시작합니다...",
		"cosmic": "우주의 클릭스터들이 당신의 진전을 자랑스러워할 것입니다!",
		"astral": "클릭이 아스트랄 차원을 울립니다...",
		"speaking": "잠깐... 들리시나요? 클릭이 저에게 말을 걸고 있어요...",
		"ancient": "당신의 클릭이 고대의 힘과 공명합니다!",
		"sages": "클릭 현자들이 당신의 잠재력을 속삭입니다...",
		"demons": "보라! 클릭 악마들이 잠에서 깨어난다!",
		"veil": "당신의 클릭이 현실의 장막을 관통합니다!",
		"spirits": "클릭의 영혼들이 당신의 리듬에 맞춰 춤춥니다...",
		"council": "위대한 클릭 의회가 당신의 헌신을 알아차렸습니다",
		"primordial": "당신의 클릭이 태초의 힘을 깨웁니다!",
		"void": "클릭의 공허가 당신을 응시합니다...",
		"runes": "고대의 클릭 룬이 당신의 힘으로 빛납니다!",
		"beast": "셋 셋 셋 - 클릭 괴수의 숫자",
		"prophets": "클릭 예언자들이 당신의 도래를 노래합니다!",
		"dimensions": "당신의 클릭이 차원을 관통하여 울립니다...",
		"portal": "당신의 클릭이 클릭 차원으로 가는 포털을 열었습니다!",
		"sacrifice": "고대의 클릭 신들이 더 많은 희생을 요구합니다",
		"jackpot": "잭팟! 클릭 카지노가 새로운 챔피언을 환영합니다!",
		"unmatched": "당신의 클릭 파워는 비할 데가 없습니다!",
		"reality": "현실 자체가 당신의 클릭 의지에 굴복합니다!",
		"elite": "당신은 엘리트 클릭 마스터가 되었습니다",
		"power": "당신의 클릭 파워 레벨이 1500을 넘었습니다!",
		"devils": "클릭 악마들이 당신의 힘 앞에 무릎 꿇습니다",
		"lucky": "행운의 클릭이 당신의 핏줄을 타고 흐릅니다",
		"dynasty": "클릭 왕조가 당신의 패권을 인정합니다",
		"twoThousand": "순수한 힘의 이천 번째 클릭!",
		"quartet": "클릭 4중주의 예언이 실현되었습니다",
		"transcend": "당신의 클릭이 필멸자의 이해를 초월합니다",
		"constellation": "클릭 별자리가 당신을 기리며 정렬합니다",
		"destiny": "운명의 삼천 번째 클릭",
		"triforce": "삼중 클릭의 트라이포스가 깨어납니다!",
		"fortune": "행운은 끈기 있는 클리커의 편",
		"newDimensions": "당신의 클릭 파워가 새로운 차원에 도달합니다",
		"quartet2": "4중 클릭 콰르텟이 조화를 이룹니다",
		"threshold": "클릭 신성의 문턱에 서 있습니다",
		"ultimate": "궁극의 힘, 오천 번째 클릭!",
		"force": "오수 클릭 포스가 당신의 명령을 따릅니다",
		"underworld": "클릭 지하세계가 당신을 그들의 통치자로 추대합니다",
		"maxJackpot": "최대 잭팟 클릭 달성",
		"infinite": "무한한 클릭의 힘!",
		"godhood": "당신은 클릭의 신격에 올랐습니다",
		"burrow": "그 어떤 토끼보다 더 깊이 파고들었다...",
		"warren": "위대한 토끼굴이 당신의 존재를 인정합니다...",
		"thump": "당신의 발을 구를 때마다 대지가 진동합니다!",
		"darkWarren": "어둠의 토끼굴이 당신을 위해 문을 엽니다...",
		"ears": "귀가 점점 길어진다... 이제 모든 것이 들린다...",
		"carrotThrone": "당근 왕좌가 당신 앞에 나타납니다...",
		"onesAlignment": "모든 일이 정렬됩니다 - 토끼굴 주파수가 공명합니다!",
		"moonSummon": "달토끼가 허공을 넘어 당신의 부름을 듣습니다...",
		"edgeOfForever": "영원의 가장자리에 서 있습니다... 귀가 떨리며...",
		"beyondTheVeil": "장막 너머, 모든 토끼굴이 하나가 됩니다...",
		"sequence": "1-2-3-4-5... 신성한 호핑 시퀀스가 완성되었습니다!",
		"hyperElite": "하이퍼 엘리트 토끼 상태 해제 🐇🐇🐇",
		"eventHorizon": "우주 토끼굴의 사건의 지평선을 넘어서...",
		"matrixAwakens": "토끼굴 매트릭스에 글리치... 현실 뒤의 당근이 보인다",
		"luckyForever": "모든 발, 모든 도약, 모든 떨림... 영원히 축복받다",
		"twentyK": "이만. 당신은 더 이상 토끼가 아닙니다. 당신이 바로 그 토끼입니다.",
		"singularity": "토끼 특이점. 모든 토끼는 당신이다. 당신은 모든 토끼다.",
		"tripleAscension": "우주 토끼의 삼중 승천!",
		"ultimateAnswer": "42,000 - 궁극의 답은 처음부터 당근이었다",
		"eternity": "♾️ 영원한 토끼굴에는 끝이 없다. 당신도 마찬가지. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} 보너스 포인트!",
		"clickStreak": "🔥 {{count}}번 연속 클릭!",
		"fire": "🔥 파이어 파워 발동!"
	},
	"table": {
		"achievement": "업적",
		"progress": "진행도"
	},
	"reset": {
		"confirm": "모든 진행 상황을 초기화하시겠습니까? 이 작업은 취소할 수 없습니다."
	}
}
